// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M3z9I","clinicsSelect":"styles_clinicsSelect__1HKuP"};